import {
  GET_CURRENT_USER,
  GET_OTP,
  GET_OTP_ERROR,
  GET_OTP_LOADING,
  GET_OTP_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_ERROR,
  LOGOUT_USER_SUCCESS,
  VERIFY_OTP,
  VERIFY_OTP_ERROR,
  VERIFY_OTP_LOADING,
  VERIFY_OTP_SUCCESS,
  VERIFY_USER,
  VERIFY_USER_ERROR,
  VERIFY_USER_SUCCESS,
} from "./constant";

const userOTP = {
  loading: false,
  success: false,
  data: null,
  error: "",
};

const verifyOtp = {
  loading: false,
  success: true,
  data: null,
  error: "",
};

const user = {
  data: null,
  success: false,
  error: "",
};

const initialState = {
  userOTP: { ...userOTP },
  verifyOtp: { ...verifyOtp },
  user: { ...user },
};

export const AuthReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // GET OTP state reducer
    case GET_OTP:
      return { ...state, ...userOTP };
    case GET_OTP_LOADING:
      return { ...state, userOTP: { ...userOTP, loading: true } };
    case GET_OTP_SUCCESS:
      return {
        ...state,
        userOTP: { ...userOTP, success: true, data: payload },
      };
    case GET_OTP_ERROR:
      return { ...state, userOTP: { ...userOTP, error: payload } };

    // Verify OTP state reducer
    case VERIFY_OTP:
      return { ...state, ...verifyOtp };
    case VERIFY_OTP_LOADING:
      return { ...state, verifyOtp: { ...verifyOtp, loading: true } };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        verifyOtp: { ...verifyOtp, success: true, data: payload },
      };
    case VERIFY_OTP_ERROR:
      return { ...state, verifyOtp: { ...verifyOtp, error: payload } };

    // Verify User state reducer
    case GET_CURRENT_USER:
    case VERIFY_USER:
      return { ...state, ...user };
    case VERIFY_USER_SUCCESS:
      return {
        ...state,
        user: { ...user, data: payload, success: true },
      };
    case VERIFY_USER_ERROR:
      return { ...state, user: { ...user, error: payload } };
    case LOGOUT_USER:
      return { ...state };
    case LOGOUT_USER_ERROR:
    case LOGOUT_USER_SUCCESS:
      localStorage.clear();
      return {
        ...state,
        user: { data: null, success: false, error: "" },
        userOTP: { ...userOTP },
      };
    default:
      return { ...state };
  }
};
